import 'ol/ol.css';
import './App.css';
import Config from './config.json';

import styled from "styled-components";
import { useState, useEffect, forwardRef } from 'react';
import TopMenu from "./components/TopMenu";
import LeftMenu from "./components/LeftMenu";
import MapContainer from "./components/MapContainer";
import { IconButton, Slide } from '@material-ui/core';
import {  Close } from '@material-ui/icons';
import Area from './components/Area/Area';
import Data from './components/Data/Data';
import SelectArea from './components/Area/SelectArea';
import BrowseData from './components/Data/BrowseData';
import ImportData from './components/Data/ImportData';
import Analysis from './components/Analysis/Analysis';
import Statistic from './components/Statistic/Statistic';
import Digsig from './components/Digsig/Digsig';
import About from './components/About/About';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  appBar: {
    position: 'relative',
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
}));

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});


function Maintainance() {
  const classes = useStyles();
    

  return (
    <Container>
     
      <TopMenu />
      <Main>
        <Message>
            <p>
            We are upgrading.. Will be back soon..
            </p>
        </Message>
      </Main>

    </Container>
  );
}

export default Maintainance;

const Container = styled.div`
  display: flex;
  height:100vh;
  flex-direction: column;
`;

const Main = styled.div`
  display: flex;
  flex-grow: 1;
  height: 92vh;
  justify-content: center;
`;

const Sidebar = styled.div`
  height: 90vh;
  width: 330px;
  position: fixed;
  z-index: 1;
  top: 0;
  left: 0;
  margin-left: 70px;
  margin-top: 9.25vh;
  background-color: white;
  overflow-x: hidden;
  overflow-y: hidden;
  transition: 0.8s;
  border-right: 1px solid #eee;
`;

const Closer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 5px;
`;

const SidebarTitle = styled.h3`
  padding-left:17px;
`;

const SideHelper = styled.div`
  display: flex;
  width:280px;
  overflow-x: hidden;
  overflow-y: hidden;
  transition: 0.5s;
  flex-direction: column;
  background-color: red;
`;

const LeftTopMenu = styled.div`
  display:flex;
  width: 250px;
  justify-content: flex-start;
  align-items: center;
  padding: 10px;
`;

const Logo = styled.div`
  padding-left: 5px;
`;


const Content = styled.div`
  background-color:white;
  flex-grow: 1;
  display: flex;
  width: 100%;

`;


const TopSearch = styled.div`
  display:flex;
  align-items: center;
`;


const Message = styled.div`
  width:280px;
  transition: 0.5s;
`;